export default __webpack_public_path__ + "static/media/bookcover - front.37f96c58.png";